import React from 'react';
import Modal from 'react-modal';
import { useState, useEffect } from 'react';

// css 
import './ComponentsCss/AdminPage.css';
// pages 
import AdminPageLawyerEdit from './AdminPageLawyerEdit';
import AdminPageMsEdit from './AdminPageMsEdit';
import AdminPageNewsEdit from './AdminPageNewsEdit';
const AdminPage = ({ ModalOpenCallBack, ModalDataCallBack }) => {

  const [AdminSel, SetAdminSel] = useState(0);
  const customStylesColorPicker = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '90%',
      height: '80%'
    },
  };

  const [ModalIsOpen, setModalIsOpen] = useState(true);
  function onCloseModal() {
    console.log("Close modal");
    setModalIsOpen(false);
    ModalOpenCallBack(false);
    ModalDataCallBack("SOME BLOB DATA ");
  }
  return (
    <div>
      <Modal
        isOpen={ModalIsOpen}
        onRequestClose={onCloseModal}
        style={customStylesColorPicker}
        contentLabel="Modal Test"
        ariaHideApp={false}>

        <div className='admin-page-top-bar'>
          <div className={AdminSel == 0 ? 'admin-page-button admin-page-bg' : 'admin-page-button'} onClick={() => SetAdminSel(0)}> 전문회원 관리  </div>
          <div className={AdminSel == 1 ? 'admin-page-button admin-page-bg' : 'admin-page-button'} onClick={() => SetAdminSel(1)}> 월간 선진 관리  </div>
          <div className={AdminSel == 2 ? 'admin-page-button admin-page-bg' : 'admin-page-button'} onClick={() => SetAdminSel(2)}> 사건게시판 관리  </div>
        </div>
        <div className='admin-page-main-frame'>
          {
            AdminSel == 0 ?
              <AdminPageLawyerEdit />:
              AdminSel == 1 ?
               <AdminPageMsEdit /> :
                AdminSel == 2 ?
                  <AdminPageNewsEdit />:
                    null
                  }
        
        </div>
      </Modal>

    </div>
  )
}

export default AdminPage